export enum ContactComponentContextEnum {
	DEFAULT = '',
	INTERNAL = 'internal',
	CLIENT = 'client',
	SITE = 'site',
	CLIENT_ALL = 'client-all'
}
